import React from "react";
import Footer from "./footer";

function App() {
  return (
    <div className="h-full w-full bg-black">
      <div className="p-20 md:p-10 md:flex md:flex-wrap ">
        <img className="md:h-96 md:w-96  rounded-full h-36 w-36  " src="./resources/head1.jpg" alt="head"/>
        <div className=" md:ml-20 md:pt-20 md:w-7/12 text-slate-200 md:text-3xl font-semibold italic"><span className="text-3xl border-b-2">Hi I'm <span className="text-green-400 text-4xl">Anirudh</span></span> <br/> A mechanical engineer to-be and an avid tech enthusiast developing skills in software. I am interested in <span className="text-green-400">Web Development and design</span>. Currently finding my way around it. I also play the guitar sometimes.</div>
      </div>
      <div className="block m-auto md:mb-72 mb-36 h-20 w-96 bg-opacity-20 rounded-xl bg-white text-white">
      <ul className="flex justify-evenly p-5">
        <li><a href="https://www.linkedin.com/in/anirudha2003/">
        <img className="rounded-full h-10 w-10 " src="./resources/li.png" alt="head"/></a>
        </li>
        <li><a href="https://www.instagram.com/4n1rudha/">
        <img className="rounded-full h-10 w-10 " src="./resources/in.png" alt="head"/></a>
        </li>
        <li><a href="https://github.com/4n1rudh4">
        <img className="rounded-full h-10 w-10 " src="./resources/11.png" alt="head"/></a>
        </li>
      </ul>
      </div>
      <div  className="flex justify-center">
      <Footer/>
      </div>
    </div>
  );
}

export default App;
